import React from 'react'
import { Link } from 'react-router-dom'

function NavBar() {
  function colourise(e) {
    e.target.style.color = 'orangered';
  }

  function decolourise(e) {
    e.target.style.color = 'black';
  }

  return (
    <header className="Nav-bar">
      <div className="row">
        <div className="col-md-4 testimonials">
          <Link to="/creating">
            <h3 onMouseEnter={colourise} onMouseLeave={decolourise}>CREATING</h3>
          </Link>
        </div>
        <div className="col-md-4 nav-about">
          <Link to="/about">
            <h2 onMouseEnter={colourise} onMouseLeave={decolourise}>ELLA GILBERT</h2>
          </Link>
        </div>
        <div className="col-md-4 things-i-like">
          <Link to="/coaching">
            <h3 onMouseEnter={colourise} onMouseLeave={decolourise}>COACHING</h3>
          </Link>
        </div>
      </div>
    </header>
  )
}

export default NavBar
